import { render, staticRenderFns } from "./aiTongyong.vue?vue&type=template&id=25051a15&scoped=true"
import script from "./aiTongyong.vue?vue&type=script&lang=js"
export * from "./aiTongyong.vue?vue&type=script&lang=js"
import style0 from "./aiTongyong.vue?vue&type=style&index=0&id=25051a15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25051a15",
  null
  
)

export default component.exports